<template>
  <ValidationObserver v-slot="{ invalid }" tag="section" class="container-fluid">
    <div class="row box">
      <div class="col-12">
        <h2>Create spotlight</h2>
        <form name="edit-module" role="form">
          <div class="row">
            <ValidationProvider v-slot="{ errors }" name="spotlight title" tag="div" class="col-5">
              <div class="form-group" :class="{'has-error': errors[0]}">
                <label for="title">Spotlight Title: *</label>
                <input id="title" v-model.trim="spotlightData.title" type="text" class="form-control" required="required">
                <small class="text-danger">{{ errors[0] }}</small>
              </div>
            </ValidationProvider>
            <div class="col-2">
              <div class="form-group">
                <label for="draft">draft-mode:</label><br>
                <input id="draft" v-model.lazy.trim="spotlightData.draft" type="checkbox" name="draft" value="1">
              </div>
            </div>
            <div v-if="spotlightData.sku" class="col-5">
              <div class="form-group">
                <label for="sku">SKU:</label>
                <input id="sku" v-model.lazy.trim="spotlightData.sku" type="text" class="form-control" name="sku" disabled="true">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="subline">Subline:</label>
                <froala-editor
                  id="subline"
                  v-model="spotlightData.subline"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="author">Author / Footnote:</label>
                <input id="author" v-model.lazy.trim="spotlightData.author" type="text" class="form-control" name="author">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="date">Date Information:</label>
                <input id="data" v-model.lazy.trim="spotlightData.date" type="text" class="form-control" name="date">
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="topics">Topics: </label>
                <input id="topics" v-model.lazy.trim="spotlightData.topics" type="text" class="form-control" name="topics" placeholde="topic 1,topic 2,third topic">
              </div>
            </div>
          </div>
        </form>
      </div>
      <hr>
      <SaveBar
        :saveDisabled="invalid"
        @save="createSpotlight(close = false)"
        @saveAndClose="createSpotlight(close = true)"
        @cancel="cancel"
      />
    </div>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'createSpotlight',
  components: {
  },
  data () {
    return {
      spotlightData: {
        draft: 1
      }
    }
  },
  computed: {
    isLoading: {
      get () {
        return this.$store.getters.getLoadingState
      },
      set (val) {
        this.$store.commit('SET_LOADING_STATE', val)
      }
    }
  },
  watch: {
    $route (route) {
      if (route.params.id) {
        this.loadData(route.params.id)
      }
    }
  },
  created () {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id)
    }
  },
  methods: {
    cancel () {
      this.$router.push('/clients/' + this.$route.params.client + '/spotlights')
    },
    createSpotlight (close = false) {
      this.isLoading = true
      this.$store
        .dispatch('createSpotlight', { spotlightId: this.spotlightData.id, client: this.$route.params.client, data: this.spotlightData })
        .then(response => {
          this.$swal({
            title: 'Success',
            text: 'Spotlight was updated',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            position: 'top',
            timer: 2000
          })
          this.isLoading = false
          if (close) {
            this.cancel()
            return
          }

          if (!this.$route.params.id) {
            this.$router.push('/clients/' + this.$route.params.client + '/spotlights/' + response.data.id)
            return true
          }
        }).catch(error => {
          this.isLoading = false
          this.$swal({
            title: 'Error',
            text: 'Could not save spotlight: ' + error,
            icon: 'error'
          })
        })
    }
  }
}
</script>

<style>
</style>
